<template>
    <preview
        :aspect="aspect"
        :resolution="resolution"
        :url="preview_url">
    </preview>
</template>

<script>
    import preview from '../content/common/preview.vue'
    import toaster from "./toaster";

    export default {
        components: {
            preview
        },
        props: ['type'],
        data: function() {
            return {
                t_preview_failed: Lang.langGet('Failed to load preview!'),
                preview_url: '',
                aspect: '16:9',
                resolution: '1920x1080'
            }
        },
        methods: {
            preview: function(element_id, element_parameters) {
                let parameters = typeof element_parameters === 'object' ? element_parameters : JSON.parse(element_parameters)
                this.aspect = parameters.format
                this.resolution = parameters.resolution

                axios.post('/content/preview', {
                    elements: element_id,
                    type: this.type,
                    parameters: parameters
                }).then((response) => {
                    this.preview_url = response.data.data.url
                    EaseEventBus.fire('showContentPreview');
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login'
                    }

                    toaster.error(this.t_preview_failed)
                })
            }
        },
        mounted() {
            EaseEventBus.listen('previewTemplate', (data) => {
                this.preview(data.id, data.parameters)
            })

            EaseEventBus.listen('previewCampaign', (data) => {
                this.preview(data.id, data.parameters)
            })

            EaseEventBus.listen('hidePreview', (data) => {
                this.preview_url = ''
            })
        }
    }
</script>
